import React from 'react';
import {Route} from 'found';

import Wizard from './wizard';

import ReferenceSelection from './reference';
import Isolate from './isolate';
import RxList from './rx-list';
import SuscResults from './susc-results';
import SuscResultsOpt from './susc-results/opt';
import Finish from './finish';

const routes = (
  <Route
   path="wizard"
   Component={Wizard}>
    <Route
     path="reference"
     Component={ReferenceSelection} />
    <Route
     path="isolate"
     Component={Isolate} />
    <Route
     path="rx-list"
     Component={RxList} />
    <Route
     path="susc-results/opt"
     Component={SuscResultsOpt} />
    <Route
     path="susc-results"
     Component={SuscResults} />
    <Route
     path="finish"
     Component={Finish} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/views/wizard/routes.js